import { useState, useRef, useMemo } from "react";
import { Marker, Popup } from 'react-leaflet';
import Parser from "html-react-parser";
import RadioCoveragePopup from "../Popups/RadioCoveragePopup";

const HoverMarker = ({ deviceType, marker, icon, onClick, isDraggable = false, onDragEnd,moveDevice,
}) => {
  const [position, setPosition] = useState([marker.lat, marker.lng]);
  const markerRef = useRef(null);

  const eventHandlers = useMemo(
    () => ({
      mouseover: (e) => e.target.openPopup(),
      click: () => onClick?.(marker),
      dragend: async() => {
        const m = markerRef.current;
        if (m != null) {
          const newPos = m.getLatLng();
          const confirmed = window.confirm("Είστε σίγουϝοι ότι θέλετε να μετακινήσετε τη συσκευή;");

          if (!confirmed) {
            m.setLatLng([marker.lat, marker.lng]);
            return;
          }
          const result = await moveDevice(marker, newPos);
          if (result.status === 200) {
            setPosition([newPos.lat, newPos.lng]);
            onDragEnd?.(newPos, marker);
          } else {
            m.setLatLng([marker.lat, marker.lng]);
          }
        }
      },
    }),
    [marker, onClick, onDragEnd, moveDevice]
  );

  if (!marker) return null;

  return (
    <Marker
      key={`marker-${marker.id || marker.lat}-${marker.lng}`}
      position={position}
      icon={icon}
      draggable={isDraggable}
      eventHandlers={eventHandlers}
      ref={markerRef}
    >
    {deviceType !== "manage" && (
      deviceType === "radioCoverage" ? (
        marker.id ? (
          <Popup>{marker.name}</Popup>
        ) : (
          <Popup>
            <RadioCoveragePopup marker={marker} />
          </Popup>
        )
      ) : (
        <Popup>{marker.popUp ? Parser(marker.popUp) : marker.deviceName}</Popup>
      )
    )}
    </Marker>
  );
};

export default HoverMarker;
